import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import AuthService from '../../../Services/authService';
import OfficeHelper from '../../../Helpers/ModelHelpers/OfficeHelper';

export default class TpClientInvoiceSearchParams extends SearchParamsBase {
  initialize() {
    this.TpClientInvoiceId = '';
    this.ClientNameOrId = '';
    this.Statuses = ['Draft'];
    this.OfficeIds = OfficeHelper.GetDefaultOfficeIds(TpClientInvoiceSearchParams.getUserOffice());
    this.IsUnpaid = '';
    this.IsPastDue = '';
    this.Yrmo = '';
    this.Ponumber = '';
    this.InvoiceNumber = '';
  }

  static iconName = 'fa-solid fa-search';
  static saveType = 'TpClientInvoiceSearchParams';

  static getUserOffice() {
    const user = AuthService.getInstance().GetLoggedInUser();
    return user.officeId;
  }

  static fieldsInSearchBox = [
    { fieldName: 'TpClientInvoiceId', label: 'Bare Invoice #', className: 'col-4', type: InputTypesEnum.Number },
    { fieldName: 'ClientNameOrId', label: 'Client Name or ID', className: 'col-4', type: InputTypesEnum.Text },
    {
      fieldName: 'Statuses',
      label: 'Status',
      className: 'col-4',
      type: InputTypesEnum.LookupTextMultiChoice,
      options: 43,
    },
    { fieldName: 'OfficeIds', label: 'Office', className: 'col-4', type: InputTypesEnum.OfficeOrGroupMultiSelect },
    { fieldName: 'IsUnpaid', label: 'Unpaid', className: 'col-4', type: InputTypesEnum.EmptyYesNoSelect },
    { fieldName: 'IsPastDue', label: 'Past Due', className: 'col-4', type: InputTypesEnum.EmptyYesNoSelect },
    { fieldName: 'Yrmo', label: 'YRMO', className: 'col-4', type: InputTypesEnum.Number },
    { fieldName: 'Ponumber', label: 'PO #', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'InvoiceNumber', label: 'Client Invoice #', className: 'col-4', type: InputTypesEnum.Text },
  ];
}
